import { BaseConnection } from "./connection";

export enum SystemAncillaryType {
  Vyākhyātantra = "vyākhyātantra",
  Uttaratantra = "uttaratantra",
  Commentary = "commentary",
  SubCommentary = "sub_commentary",
  Ritual = "ritual",
  Other = "other",
}

export const SYSTEM_ANCILLARY_TYPE_LABELS: Record<SystemAncillaryType, string> =
  {
    [SystemAncillaryType.Vyākhyātantra]: "Vyākhyātantra",
    [SystemAncillaryType.Uttaratantra]: "Uttaratantra",
    [SystemAncillaryType.Commentary]: "Commentary",
    [SystemAncillaryType.SubCommentary]: "Sub-commentary",
    [SystemAncillaryType.Ritual]: "Ritual",
    [SystemAncillaryType.Other]: "Other",
  };
export type AncillaryConnection = BaseConnection & {
  work_ancillary_type: SystemAncillaryType | null;
};

export interface AncillaryConnectionFilters extends BaseConnection {
  work_ancillary_type?: SystemAncillaryType[];
}
